import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabservicenearmemumbai() {



    const cardData = {




keyword: "Cab Service Near Me Mumbai",

headingDescription: "Shreesha Tours & Travels offers fast, reliable, and affordable Cab Service Near Me in Mumbai with doorstep pickup for local rides, airport transfers, railway station transfers, corporate travel, hotel transfers, one-way cabs, round-trip taxis, and outstation journeys. Whether you need an immediate taxi near your location or are planning a comfortable long-distance trip, we provide clean, well-maintained vehicles driven by experienced and professional chauffeurs. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury cars to suit every travel requirement. With transparent pricing, instant booking assistance, flexible pickup timings, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, comfortable, and hassle-free journey. Our outstation cab services from Mumbai are ideal for business travelers, families, tourists, pilgrims, and corporate clients looking for dependable transportation to popular destinations across Maharashtra, Gujarat, Goa, Karnataka, Madhya Pradesh, and Rajasthan.",

topPlaces: [
  {
    title: "Mumbai to Pune",
    description: "Pune is the most frequently booked outstation destination from Mumbai, known for its IT parks, educational institutions, business hubs, and historical attractions. It is perfect for corporate travel, airport transfers, family visits, and weekend trips."
  },
  {
    title: "Mumbai to Lonavala",
    description: "Lonavala is a scenic hill station famous for Tiger Point, Bhushi Dam, Rajmachi Fort, waterfalls, and lush green valleys. It is one of the most popular weekend getaway destinations from Mumbai."
  },
  {
    title: "Mumbai to Mahabaleshwar",
    description: "Mahabaleshwar is a beautiful hill station known for Venna Lake, Arthur's Seat, Elephant's Head Point, strawberry farms, and breathtaking viewpoints. It is an ideal destination for couples, families, and nature lovers."
  },
  {
    title: "Mumbai to Shirdi",
    description: "Shirdi is one of India's most important pilgrimage destinations, attracting millions of devotees visiting the sacred Shri Sai Baba Samadhi Mandir. Comfortable cab services make the spiritual journey convenient and relaxing."
  },
  {
    title: "Mumbai to Nashik",
    description: "Nashik is famous for Trimbakeshwar Jyotirlinga, Panchavati, vineyards, and the Godavari River. It is a preferred destination for religious tours, wine tourism, business travel, and family vacations."
  },
  {
    title: "Mumbai to Goa",
    description: "Goa is India's most popular beach destination, offering beautiful beaches, Portuguese churches, forts, nightlife, luxury resorts, and exciting water sports. It is one of the highest-demand long-distance cab routes from Mumbai."
  },
  {
    title: "Mumbai to Surat",
    description: "Surat is a major commercial city known for its diamond and textile industries. Business professionals and traders frequently book cabs from Mumbai to Surat for corporate meetings and industrial visits."
  },
  {
    title: "Mumbai to Ahmedabad",
    description: "Ahmedabad is Gujarat's commercial capital, famous for Sabarmati Ashram, heritage sites, textile markets, and thriving business districts. It is a preferred destination for both business and leisure travelers."
  },
  {
    title: "Mumbai to Indore",
    description: "Indore is the commercial capital of Madhya Pradesh, known for Rajwada Palace, Sarafa Food Market, Khajrana Ganesh Temple, and nearby Ujjain and Omkareshwar. It is a popular destination for business and religious travel."
  },
  {
    title: "Mumbai to Bangalore",
    description: "Bangalore is India's leading IT and startup hub, home to multinational companies, technology parks, educational institutions, and business centers. It is a preferred long-distance destination for corporate and professional travelers."
  }
],



"services": [
  {
    "name": "Cab Service Near Me Mumbai",
    "description": "Book Cab Service Near Me Mumbai for quick, safe, and reliable transportation with professional chauffeurs and well-maintained AC vehicles available across Mumbai. Choose from Sedan, Ertiga, Innova Crysta, SUV, Kia Carens, and Tempo Traveller options for local travel, airport transfers, office commuting, shopping trips, hotel transfers, railway station pickups, family outings, and outstation journeys. Enjoy doorstep pickup, transparent pricing, instant booking confirmation, and 24x7 customer support for a smooth and comfortable travel experience."
  },
  {
    "name": "Taxi Service Near Me Mumbai",
    "description": "Choose Taxi Service Near Me Mumbai for fast and dependable taxi services with experienced drivers, clean vehicles, and affordable fares. Whether you need an airport transfer, business travel, local city ride, family transportation, sightseeing tour, or outstation journey, our taxi service provides timely pickups, comfortable seating, GPS-enabled vehicles, and flexible travel options to ensure a hassle-free experience throughout Mumbai."
  },
  {
    "name": "Mumbai Cab Near Me",
    "description": "Find Mumbai Cab Near Me with instant availability and professional chauffeur-driven vehicles for comfortable travel anywhere in Mumbai. Our cab services include airport pickup and drop, local sightseeing, corporate travel, shopping trips, railway station transfers, hotel pickups, and long-distance travel with Sedan, Ertiga, Innova Crysta, SUV, and premium vehicle options available at competitive prices."
  },
  {
    "name": "Nearby Taxi Service Mumbai",
    "description": "Book Nearby Taxi Service Mumbai for quick cab availability with reliable drivers and comfortable AC vehicles. Enjoy convenient transportation for daily commuting, office travel, business meetings, airport transfers, family functions, medical visits, tourist attractions, and outstation destinations with transparent pricing and prompt doorstep pickup services."
  },
  {
    "name": "Mumbai Local Cab Service",
    "description": "Hire Mumbai Local Cab Service for convenient city transportation with experienced chauffeurs and clean, comfortable vehicles. Travel easily for shopping, business meetings, office commuting, school or college pickups, sightseeing tours, hotel transfers, railway station visits, and family outings with flexible hourly, half-day, and full-day rental options."
  },
  {
    "name": "Mumbai Fast Cab Booking",
    "description": "Choose Mumbai Fast Cab Booking for instant reservations, quick driver allocation, and reliable transportation services throughout Mumbai. Our fast booking process allows you to reserve Sedan, Ertiga, Innova Crysta, SUV, and premium vehicles within minutes for airport transfers, local travel, corporate requirements, family trips, and emergency transportation with professional chauffeurs."
  },
  {
    "name": "Mumbai 24 Hour Cab Service",
    "description": "Book Mumbai 24 Hour Cab Service for round-the-clock transportation with dependable drivers and well-maintained AC vehicles available day and night. Whether you require early morning airport transfers, late-night pickups, business travel, emergency transportation, hotel transfers, railway station pickups, or outstation travel, our 24x7 cab service ensures safe, punctual, and comfortable journeys."
  },
  {
    "name": "Mumbai Airport Cab Near Me",
    "description": "Reserve Mumbai Airport Cab Near Me for timely airport pickup and drop services with flight tracking, professional chauffeurs, and comfortable AC vehicles. Enjoy hassle-free transportation to and from Mumbai Airport with doorstep pickup, luggage assistance, affordable fares, and reliable service suitable for business travelers, families, tourists, and corporate guests."
  },
  {
    "name": "Affordable Cab Service Mumbai",
    "description": "Choose Affordable Cab Service Mumbai for budget-friendly travel without compromising on comfort, safety, or reliability. Our fleet includes Sedan, Ertiga, Innova Crysta, SUVs, and premium cars suitable for airport transfers, local travel, family outings, business meetings, sightseeing tours, and outstation journeys with transparent pricing and no hidden charges."
  },
  {
    "name": "Reliable Taxi Near Me Mumbai",
    "description": "Book Reliable Taxi Near Me Mumbai for trusted chauffeur-driven transportation with professional drivers, clean vehicles, and punctual service. Whether you need local city travel, airport transfers, hotel pickups, corporate transportation, family trips, railway station transfers, or long-distance travel, enjoy dependable taxi services with flexible booking options and excellent customer support."
  }
],
"tableData": [
  ["Cab Service Near Me Mumbai", "Taxi Service Near Me Mumbai"],
  ["Mumbai Cab Near Me", "Nearby Taxi Service Mumbai"],
  ["Mumbai Local Cab Service", "Mumbai Fast Cab Booking"],
  ["Mumbai 24 Hour Cab Service", "Mumbai Airport Cab Near Me"],
  ["Affordable Cab Service Mumbai", "Reliable Taxi Near Me Mumbai"]
],




whychoose: [
  {
    WhyChooseheading: "Trusted 'Cab Service Near Me' in Mumbai",
    WhyChoosedescription: "Looking for a dependable cab service near you in Mumbai? Shreesha Tours & Travels provides prompt taxi services for local travel, airport transfers, business meetings, sightseeing, family outings, and outstation journeys with comfortable vehicles and experienced drivers."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Mumbai",
    WhyChoosedescription: "Book a cab from your home, office, hotel, railway station, airport, or any preferred location in Mumbai. Our drivers provide timely doorstep pickup and convenient drop-off services."
  },
  {
    WhyChooseheading: "Cars for Every Travel Requirement",
    WhyChoosedescription: "Choose from Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Luxury Cars, and Mini Buses for solo travellers, families, corporate teams, and group tours."
  },
  {
    WhyChooseheading: "Quick Local & Outstation Taxi Booking",
    WhyChoosedescription: "Whether you need a nearby taxi for city travel or an outstation cab to Pune, Lonavala, Nashik, Goa, Surat, Ahmedabad, or other destinations, we provide flexible travel solutions."
  },
  {
    WhyChooseheading: "Professional Drivers with Local Route Knowledge",
    WhyChoosedescription: "Our experienced chauffeurs are familiar with Mumbai roads, traffic conditions, highways, and nearby cities, helping you reach your destination safely and comfortably."
  },
  {
    WhyChooseheading: "Flexible Booking for Every Occasion",
    WhyChoosedescription: "Reserve one-way cabs, round-trip taxis, hourly rentals, airport transfers, corporate travel, wedding transportation, or customized travel packages according to your schedule."
  },
  {
    WhyChooseheading: "Clean, Air-Conditioned & Well-Maintained Vehicles",
    WhyChoosedescription: "Every vehicle is regularly inspected, sanitized, and maintained to provide a pleasant journey with comfortable seating and ample luggage space."
  },
  {
    WhyChooseheading: "Choose Shreesha Tours & Travels for Nearby Cab Services",
    WhyChoosedescription: "Enjoy transparent pricing, responsive booking support, and reliable taxi services whenever you search for a cab service near you in Mumbai."
  }
]

};

const faqData = [
  {
    question: "How can I find a cab service near me in Mumbai?",
    answer: "Simply contact Shreesha Tours & Travels with your pickup location, and we'll arrange the nearest available cab for your journey."
  },
  {
    question: "Do you provide doorstep pickup in Mumbai?",
    answer: "Yes, we offer doorstep pickup and drop services from homes, offices, hotels, railway stations, airports, and other locations across Mumbai."
  },
  {
    question: "Which vehicles are available for nearby cab booking?",
    answer: "You can book Hatchbacks, Swift Dzire, Sedan, Ertiga, Innova, Innova Crysta, SUVs, Tempo Travellers, Luxury Cars, and Mini Buses."
  },
  {
    question: "Can I book a nearby cab for Mumbai Airport?",
    answer: "Yes, airport pickup and drop services are available for both domestic and international terminals."
  },
  {
    question: "Do you offer nearby cabs for outstation travel?",
    answer: "Yes, we provide one-way and round-trip taxis from Mumbai to destinations across Maharashtra and other states."
  },
  {
    question: "Can I hire a nearby cab for corporate travel?",
    answer: "Yes, our taxi services are available for business meetings, employee transportation, executive travel, and corporate events."
  },
  {
    question: "Are cabs available for immediate booking?",
    answer: "Yes, subject to vehicle availability, we offer quick booking assistance for immediate and scheduled travel."
  },
  {
    question: "How is the cab fare calculated?",
    answer: "The fare depends on the vehicle type, travel distance, trip duration, route, and selected service option."
  },
  {
    question: "Can I book a nearby Tempo Traveller for group travel?",
    answer: "Yes, Tempo Travellers and larger vehicles are available for family tours, corporate outings, weddings, and group trips."
  },
  {
    question: "Why choose Shreesha Tours & Travels for a cab service near me in Mumbai?",
    answer: "We provide punctual pickups, professional drivers, comfortable vehicles, transparent pricing, and reliable customer support for every journey."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Verma",
    feedback: "I searched for a cab service near me in Mumbai and booked with Shreesha Tours & Travels. The driver arrived quickly, the car was clean, and the entire trip was smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Rachana Kulkarni",
    feedback: "We needed a nearby cab for an airport transfer at short notice. Shreesha Tours & Travels provided a comfortable Innova with excellent service and an on-time pickup.",
    rating: 5
  }
];















    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab Service Near Me Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/cab-service-near-me-mumbai.webp",
  "description":
    "Book Cab Service Near Me Mumbai with Shreesha Tours & Travels for safe, comfortable, and affordable local and outstation taxi services. We provide quick cab availability with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for airport transfers, city rides, corporate travel, family trips, railway station pickups, and intercity journeys across Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/cab-service-near-me-mumbai"
  }
};





    return (
        <div>

<Helmet>
  <title>Cab Service Near Me Mumbai | Instant Taxi Booking | +91 8355835813</title>

  <meta
    name="description"
    content="Book Cab Service Near Me Mumbai with Shreesha Travels for fast and reliable local, airport, and outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta with 24x7 online booking and professional drivers."
  />

  <meta
    name="keywords"
    content="Cab Service Near Me Mumbai, Taxi Service Near Me Mumbai, Mumbai Cab Near Me, Nearby Taxi Service, Nearest Cab Service Mumbai, Local Cab Near Me Mumbai, Airport Taxi Near Me Mumbai, Online Cab Booking Mumbai, Mumbai Taxi Near Me, 24x7 Cab Service Mumbai, Nearby Outstation Cab Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/43.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabservicenearmemumbai;